var map = {
	"./en": [
		"e088",
		"lang-en"
	],
	"./en.json": [
		"e088",
		"lang-en"
	],
	"./pt": [
		"6a7b",
		"lang-pt"
	],
	"./pt.json": [
		"6a7b",
		"lang-pt"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2e98";
module.exports = webpackAsyncContext;